import { motion } from "framer-motion";

import { Container } from "@/components/common/Container";
import { Section } from "@/components/common/Section";
import { SectionHeading } from "@/components/common/SectionHeading";

import {
    fadeUp,
    staggerContainer,
    viewportOnce,
} from "@/animations/motion";

const technologies = [
    {
        category: "Frontend",
        items: [
            "React",
            "Next.js",
            "TypeScript",
            "Tailwind CSS",
        ],
    },
    {
        category: "Backend",
        items: [
            "Node.js",
            "Express",
            "NestJS",
            "PHP",
            "CodeIgniter",
            "Laravel",
        ],
    },
    {
        category: "Mobile",
        items: [
            "React Native",
            "Android",
            "iOS",
        ],
    },
    {
        category: "Database",
        items: [
            "PostgreSQL",
            "MySQL",
            "MongoDB",
            "Redis",
        ],
    },
    {
        category: "Cloud & DevOps",
        items: [
            "Docker",
            "GitHub Actions",
            "AWS",
            "Azure",
            "Linux",
        ],
    },
    {
        category: "AI & Automation",
        items: [
            "OpenAI",
            "n8n",
            "LangChain",
            "Python",
            "AI Agents",
        ],
    },
];

export function Testimonials() {
    return (
        <Section id="technologies">
            <Container>

                <SectionHeading
                    eyebrow="Technology Expertise"
                    title="Modern Technologies We Build With"
                    description="We use proven technologies, modern development practices and industry standards to build secure, scalable and future-ready software solutions."
                />

                <motion.div
                    variants={staggerContainer(0.08, 0.10)}
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                    className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-3"
                >
                    {technologies.map((group) => (
                        <motion.div
                            key={group.category}
                            variants={fadeUp}
                            className="rounded-3xl border border-border bg-card p-8 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
                        >
                            <h3 className="text-xl font-semibold">
                                {group.category}
                            </h3>

                            <div className="mt-6 flex flex-wrap gap-3">
                                {group.items.map((item) => (
                                    <span
                                        key={item}
                                        className="rounded-full border border-primary/20 bg-primary/5 px-4 py-2 text-sm font-medium"
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </Container>
        </Section>
    );
}